export default {
  num_display_days: 120,
};
